import React from 'react';

const ArrowTriangleLeftIcon = ({ width = 7, height = 13, fill = '#FFFFFF' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.33301 0.271182L6.33301 12.0146L0.461274 6.14292L6.33301 0.271182Z" fill={fill} />
    </svg>
  );
};

export default ArrowTriangleLeftIcon;
